import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  Paper,
  Container,
  Divider,
  Card,
  CardContent,
  makeStyles,
  Stepper,
  Step,
  StepLabel,
   Tabs,
  Tab,
  LinearProgress,
} from "@material-ui/core";
import { useStyles } from "../styles";
import { useHistory } from "react-router-dom"; 
import HomeIcon from '@mui/icons-material/Home';
import GradingIcon from '@mui/icons-material/Grading';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'; 
import Logo from "../components/Logo";
import { Store } from "../Store";
import { Alert } from "@material-ui/lab";
import {
  createOrder,
  setPaymentType,
  generateQrCode,
  clearOrder,
  getCheckoutUrl,
  getUserData,
  setCustomerId,
} from "../actions";
import QRCode from "react-qr-code";
import axios from "axios";
import config, { getParameterByName, merchantCode } from "../util";
//import BillPrint from "./BillPrint";
import { useIntl } from "react-intl";
import BillSummary from "../components/Bill_Summary";
import TrackingScreen from './TrackingScreen';
import SafeQRCode from '../components/SafeQRCode'; // Import the safe QRCode component
import useResizeObserverSafe from '../utils/useResizeObserverSafe';
import SafeButton from '../components/SafeButton'; // Import the SafeButton component
import { CheckCircle, AccessTime, RestaurantMenu } from '@material-ui/icons';

export default function CompleteOrderScreen(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [checkingOrderStatus, setCheckingOrderStatus] = useState(false);  // State to track order status checking
  const history = useHistory();
  const [display, setDisplay] = useState(false);
  const [fontColor, setFontColor] = useState();
  const [detailview, setDetailView] = useState(false);
  const [orderAccepted, setOrderAccepted] = useState(false);
  const [order, setOrder] = useState(null);
   const [tabSel, setTabSel] = React.useState(1);
  //let { setting } = state.userSetting;
  let userData =localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):null;
  const baseURL = config.baseURL;
  const orderId = getParameterByName('ord_id');
  //const orderId = getParameterByName('ord_id');
  const merchantCode = getParameterByName('merchantCode');
  const handleBack = () => {
    //setDisplayOrder(false);
    return props.history.push("/?" + window.location.href.split("?")[1]);
  };

  const backSpaceImage = () => {
    return (
      <img
        src="/images/backspace-1.png"
        alt="backSpace"
        height="40vh"
        width="40vw"
      />
    );
  };

  useEffect(() => {
    //ord ? order.orderItems : "";
  
    // axios.patch(`${config.baseURL}/api/temporders/${orderId}?merchantCode=${merchantCode}`, {isPaid:true}).then(() => {
    //   console.log('order paid');
    // });

    
  }, []);
      const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  const goto =(subpath) =>{
      history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }
  // Function to check if order has been accepted
  const checkOrderAcceptance = async () => {
    setCheckingOrderStatus(true);
    try {
      let response = await axios.get(
        `${config.baseURL}/api/temporders/${orderId}/?merchantCode=${merchantCode}`
      );
      console.log(response);
      //setOrder(response.data);
      if (response.data && response.data.orderStatus === "ACCEPTED") {
        setOrderAccepted(true);
        setDetailView(true);
        response = await axios.get(
        `${config.baseURL}/api/orders/${response.data.orderId}/?merchantCode=${merchantCode}`

      );
      
      }
      setOrder(response.data);
    } catch (error) {
      console.error('Error checking order status:', error);
    } finally {
      setCheckingOrderStatus(false);
    }
  };

  useEffect(() => {
      checkOrderAcceptance();
      window.statusCheckInterval = setInterval(() => {
        checkOrderAcceptance();
      }, 30000);
      return () => {
        if (window.statusCheckInterval) {
          clearInterval(window.statusCheckInterval);
          window.statusCheckInterval = null;
        }
      };
  }, []);

  const OrderStatusIndicator = () => {
    return (
      <Card style={{margin:"10px"}}>
          <Box>

                    <Typography variant="h5" component="div" style={{ 
                      marginTop: 10,
                      marginBottom: 10,
                      color: userData?.themeTxtColor, 
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{ marginRight: 8 }}>✅</span>
                      Order Confirmed

                    </Typography>
                    <h3>{order?"Token #" + order?.number:""}</h3>
             
          
            <Typography variant="h6" >
              {order && orderAccepted
                ? "Restaurant has accepted your order!" 
                    : "Waiting for restaurant to accept your order..."
              }
            </Typography>
            {!orderAccepted && (
              <Typography variant="body2" color="textSecondary">
                Confirming your order, Please wait...
              </Typography>
            )}
       
        </Box>
        
        {!orderAccepted && (
          <Box >
            <LinearProgress color="secondary" />
          </Box>
        )}
      </Card>
    );
  };


  return (
    <Box className={[styles.root, styles.navy]} style={{ backgroundColor: userData.themeColor, overflow:"hidden", overflowY:"auto" }}>
    <Box
      id="paymentroot"
      style={{
        backgroundColor: userData?.themeColor,
        color: userData?.themeTxtColor,
        alignItems: "center",
        width:"100%",
        textAlign:"center"
      }}
    >
                <Typography
                  gutterBottom
                  variant="h4"
                  component="h1"
                  id="title2"
                >
                  {"Order Status"}
                </Typography>

               
                <Divider style={{ marginBottom: 16 }} />

                 <Box>
                 {!orderAccepted && <CircularProgress></CircularProgress>}
                <h3 style={{padding:"5px 20px"}}>{orderAccepted 
                    ? t({ id: "order_placed" }): "Please wait, while we confirm your order with Restaurant."}</h3>

                </Box>
                
                {(detailview) && (
                  <OrderStatusIndicator />
                )}
                    
                    {/* Show pickup instructions if this is a pickup order */}
                    {detailview && orderAccepted && order && order.orderType === 'Pick Up' && (
                      <Box 
                        my={3}
                        p={3}
                        style={{
                          border: '2px solid #4CAF50',
                          borderRadius: '8px',
                          backgroundColor: '#F1F8E9',
                          textAlign: 'center'
                        }}
                      >
                        <Typography 
                          variant="h6" 
                          style={{ 
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#FFF',
                            marginBottom: '8px'
                          }}
                        >
                          <RestaurantMenu style={{ marginRight: '8px' }} />
                          Pickup Instructions
                        </Typography>
                        <Typography>
                          Your order is confirmed and will be ready for pickup soon.
                        </Typography>
                        <Typography style={{ marginTop: '8px', fontWeight: 'bold' }}>
                          Please collect your order from the restaurant counter.
                        </Typography>
                        {order && order.number && (
                          <Typography style={{ marginTop: '16px', fontSize: '20px' }}>
                            Order #: <span style={{ fontWeight: 'bold', color: '#2E7D32' }}>{order.number}</span>
                          </Typography>
                        )}
                      </Box>
                    )}

                    {/* Show map/tracking only when order is accepted and not pickup */}
                    { detailview && orderAccepted && order && order.orderType !== 'Pick Up' && order.deliveryDetails?.driverAssignments[0]?.status == "PICKED_UP" &&
                      <Box 
                        my={3}
                        boxShadow={3}
                        borderRadius="borderRadius"
                        overflow="hidden"
                        style={{
                          border: '2px solid #e0e0e0',
                          position: 'relative'
                        }}
                      >
                        <TrackingScreen  history={props.history}/>
                      </Box>
                }
    </Box>
     <Tabs 
        style={{
          backgroundColor: userData.themeTxtColor,
          borderTop: "2px solid " + userData.themeColor,
          padding:"10px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
}
